import { useState } from "react";
import { useRouter } from "next/router";
import BaseModal from "./BaseModal";
import WordingTemplateAutoComplete from "~/components/app/WordingTemplateAutoComplete";
import { Menu, Form, Button, Checkbox } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { banUser } from "~/redux/actions/user";
import { onInputChange } from "~/utils/form";

const Modal = (props) => {
  const router = useRouter();
  const [form] = Form.useForm();
  const [reason, setReason] = useState();
  const [templateId, setTemplateId] = useState(null);

  const {
    query: { id },
  } = router;

  // props
  const { token } = props;

  const [state, setState] = useState({
    ban_ip: false,
    delete_user: false,
    delete_traces: false,
    reason: "",
  });

  const handleInputChange = onInputChange({ state, setState });

  const handleSubmit = async () => {
    await form.validateFields();

    props.banUser(
      token,
      id,
      {
        ...state,
        reason: reason,
        reason_template_id: templateId,
      },
      () => {
        props.hideModal();
        router.reload();
      }
    );
  };

  return (
    <BaseModal
      isOpen={props.isOpen}
      hideModal={props.hideModal}
      showLogo
    >
      <Menu
        mode="horizontal"
        selectedKeys={["mute"]}
      >
        <Menu.Item key="mute">用户封禁</Menu.Item>
      </Menu>

      <Form
        form={form}
        onFinish={handleSubmit}
        required
        layout="vertical"
      >
        <p>确认要封禁该用户吗？</p>
        <div style={{ marginBottom: 10 }}>
          <Form.Item
            label="封禁理由"
            required
            hasFeedback
            name="reason"
            rules={[
              { required: true },
              {
                type: "string",
                transform: (value) => value.trim(),
              },
            ]}
          >
            <WordingTemplateAutoComplete
              style={{ width: "100%" }}
              scenario="ban_user"
              onChange={(value) => {
                setReason(value);
                form.setFieldValue("reason", value);
              }}
              onSelectTemplate={(option) => {
                setTemplateId(option.id);
              }}
              placeholder="封禁理由"
            />
          </Form.Item>
          <Checkbox
            checked={state.ban_ip}
            name="ban_ip"
            onChange={handleInputChange}
          >
            同时封禁 IP
          </Checkbox>
        </div>
        <div style={{ marginBottom: 10 }}>
          <Checkbox
            checked={state.delete_traces}
            name="delete_traces"
            onChange={handleInputChange}
          >
            同时清除全部帖子和评论，此操作无法撤销
          </Checkbox>
        </div>
        <div style={{ marginBottom: 30 }}>
          <Checkbox
            checked={state.delete_user}
            name="delete_user"
            onChange={handleInputChange}
          >
            同时注销该用户，此操作无法撤销
          </Checkbox>
        </div>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
          >
            确认封禁
          </Button>
        </Form.Item>
      </Form>
    </BaseModal>
  );
};

const mapStateToProps = (state) => ({
  viewUser: state.user.viewUser,
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      banUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
